import React from 'react'
import { getDateFormated } from '../../../../js/helper'
import Typography from '@material-ui/core/Typography'


const ConfirmedEvents = ({event, classes}) =>{
        let style
    if(event.event.date>getDateFormated()){
        style = {backgroundColor: '#f50057'}
    } else {
        style = {backgroundColor: '#3f51b5'}
    }
    return (
        <div style={style}className={`${classes.canidate} ${classes.confirmed}`}>
        <Typography className={classes.canidate.lable} color='inherit' variant='body1'>
            Angebot erfolgreich vermittelt
        </Typography>
        <Typography className={classes.canidate.name} color='inherit' variant='subheading'>
            {event.canidate.name}
        </Typography>
        <Typography className={classes.canidate.lable} color='inherit' variant='body1'>
            Vermittelt am: {getDateFormated(event.admin.timeStamp, 'normal')} {getDateFormated(event.admin.timeStamp, 'untilThen')}
        </Typography>
        <Typography className={classes.canidate.lable} color='inherit' variant='body1' >
            Bestätigt am: {getDateFormated(event.timeStamp, 'normal')} {getDateFormated(event.timeStamp, 'untilThen')}
        </Typography>
    </div>
    )
}

export default ConfirmedEvents


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/View/ConfirmedEvents.js